export default __webpack_public_path__ + "static/media/inverting_buck_boost.e6d06cbe.svg";